import { LogLevel } from '@shared/logger';
import { z } from 'zod';

/**
 * Parse and validate the configuration.
 *
 * Use `z.string()` to parse string values.
 * Use `z.coerce.number()` to parse number values.
 * Use `z.coerce.boolean()` to parse boolean values.
 */
export default z.object({
  mode: z.enum(['development', 'staging', 'uat', 'production']),
  logLevel: z.nativeEnum(LogLevel).default(LogLevel.INFO),
  loginUrl: z.string().min(1).url(),
  graphql: z.object({
    apiUrl: z.string().min(1).url(),
    defaultFetchPolicy: z
      .enum(['cache-first', 'network-only', 'cache-only', 'no-cache', 'standby'])
      .optional(),
  }),
  userManagement: z.object({
    internalUserEmailDomains: z.string().transform((v) => {
      if (v === '') {
        return [];
      }
      return v.split(',').map((s) => s.trim());
    }),
    restrictedUserEmailDomains: z.string().transform((v) => {
      if (v === '') {
        return [];
      }
      return v.split(',').map((s) => s.trim());
    }),
  }),
});
